import { Component, ViewEncapsulation, ViewChild } from '@angular/core';
import { RequestsServices } from './../../services/requests.service';
import { StorageService } from './../../services/storage.service';
import { UserService } from './../../services/user.service';
// Init Blip Chat
declare const BlipChat: any;

@Component({
  selector: 'chat-bot',
  templateUrl: './chat-bot.component.html',
  encapsulation: ViewEncapsulation.None,
})

export class ChatBotComponent {
  private builder: any;
  private message: string;
  public firstCoversation: boolean = true;
  public chatLoading: boolean = false;

  constructor(private request: RequestsServices, private storage: StorageService, private userService: UserService) {
    localStorage.removeItem('blipSdkUAccount');
  }

  sendMessage(val, first?): void {
    if (first) {
      this.firstCoversation = false;
    }
    this.builder.sendMessage(val);
    this.message = '';
  }

  ngOnInit(){
    const appKey = 'YWxseWFjb252aWRhcmxvY2FsOjk2MzgyZDk5LTRiNDctNGU4OC1iYzk5LWNhZDhjYWFlMWI0ZQ==';
    let target = 'sdk-chat';
    let user = this.userService.getLoggedUser();

    this.builder = new BlipChat()
      .withAppKey(appKey)
      .withTarget(target)
      .withAccount({
        "fullName": user.name,
        "phone": user.phone,
        "email": user.activeAccount.email,
        "encryptMessageContent": true
      })
      .withEventHandler(BlipChat.ENTER_EVENT, () => {
        this.firstCoversation = true;
      })
      .withEventHandler(BlipChat.LOAD_EVENT, () => {
        this.chatLoading = true;
      })
      .withEventHandler(BlipChat.CREATE_ACCOUNT_EVENT, () => {
        this.firstCoversation = true;
      })

    this.builder.build()

  }

}

